var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "task-prop" }, [
        _c("strong", [_vm._v("Теги:")]),
        _vm._v(" "),
        !_vm.tagsOnly
          ? _c("label", { staticClass: "form-input--group task-prop__value" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.currentTag,
                    expression: "currentTag",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-input",
                attrs: { type: "text", disabled: _vm.disabled },
                domProps: { value: _vm.currentTag },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.insertTag.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.currentTag = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              !_vm.disabled
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ml-1",
                      attrs: {
                        type: "button",
                        id: "plus",
                        title: "Добавить тег",
                      },
                      on: { click: _vm.insertTag },
                    },
                    [_vm._v("Добавить тег")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "Scroll",
        {
          staticClass: "tags",
          staticStyle: { width: "100%", "max-height": "56px" },
        },
        _vm._l(_vm.tags, function (tag) {
          return _c(
            "div",
            { staticClass: "tag text-icon" },
            [
              _c("span", { staticClass: "text ellipsis" }, [
                _vm._v(_vm._s(tag.name)),
              ]),
              _vm._v(" "),
              !_vm.disabled
                ? _c("Icon", {
                    staticStyle: { "--size": "14px" },
                    attrs: { id: "delete" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteTag(tag.id || tag.tmpId)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }